import { queryClient as apiQueryClient } from '@frontend/api';

export const invalidateAllBOMRestructureQueries = () => {
  apiQueryClient.invalidateQueries(['bomRestructureInfo']);
};

export const invalidateAllAssemblyTreeQueries = () => {
  apiQueryClient.invalidateQueries(['quoteItemAssemblyTree']);
  invalidateAllBOMRestructureQueries();
};
